// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rejection-approval-page .approval-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: end;
}
.rejection-approval-page .approval-filters .form-label {
  font-size: 0.85rem;
}
.rejection-approval-page .approval-reasons {
  padding-left: 1rem;
  margin-bottom: 0;
  min-width: 160px;
}
.rejection-approval-page .approval-comments {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  min-width: 220px;
  max-width: 360px;
}
.rejection-approval-page th {
  white-space: nowrap;
}
.rejection-approval-page td {
  font-size: 0.85rem;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/transaction/RejectionApproval.scss"],"names":[],"mappings":"AACE;EAAoB,aAAA;EAAe,eAAA;EAAiB,SAAA;EAAW,gBAAA;AAIjE;AAHE;EAAgC,kBAAA;AAMlC;AALE;EAAoB,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;AAU5D;AATE;EAAqB,qBAAA;EAAuB,uBAAA;EAAyB,gBAAA;EAAkB,gBAAA;AAezF;AAdE;EAAK,mBAAA;AAiBP;AAhBE;EAAK,kBAAA;AAmBP","sourcesContent":[".rejection-approval-page {\n  .approval-filters { display: flex; flex-wrap: wrap; gap: 1rem; align-items: end; }\n  .approval-filters .form-label { font-size: .85rem; }\n  .approval-reasons { padding-left: 1rem; margin-bottom: 0; min-width: 160px; }\n  .approval-comments { white-space: pre-wrap; overflow-wrap: anywhere; min-width: 220px; max-width: 360px; }\n  th { white-space: nowrap; }\n  td { font-size: .85rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
